import clsx from "clsx"

export * from "./CourseBanner"
export * from "./CourseInfoList"
export * from "./CourseMaterialList"
export * from "./CourseReview"
export * from "./CourseSidebar"
export * from "./CourseShare"
export * from "./CourseTutor"
export * from "./CourseDescription"
export * from "./DetailCard"
export * from "./RelatedCourse"

interface CourseHeadingProps extends React.HTMLAttributes<HTMLHeadingElement> {
  customMargin?: string
}

export const CourseHeading = ({
  customMargin = "mb-2.5",
  className,
  ...props
}: CourseHeadingProps) => {
  return (
    <h2
      className={clsx("text-black font-semibold sm:text-2xl", "", customMargin, className)}
      {...props}
    />
  )
}
